import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MacroscopiaAPI from '../../macroscopia.api';
import * as actions from '../../macroscopia.action';
import CestaPage from './cesta.page';

class CestaContainer extends Component {
  constructor() {
    super();
    this.state = {
      centroResponsabilidades: undefined,
      cesta: undefined,
    };
  }

  render() {
    return (
      <CestaPage
        centroDeResponsabilidades={this.props.centroDeResponsabilidades}
        cestas={this.props.cestas}
        blocos={this.props.blocos}
        blocoNaCesta={this.props.blocoNaCesta}
        onChangeCesta={this.onChangeCesta.bind(this)}
        onChangeCentroDeResponsabilidade={this.onChangeCentroDeResponsabilidade.bind(
          this
        )}
        onClickCheckboxBloco={this.onClickCheckboxBloco.bind(this)}
      />
    );
  }

  componentDidMount() {
    MacroscopiaAPI.getCentroResponsabilidade().then((centro) => {
      this.props.actions.preencherCentroResponsabilidade(centro);
    });

    MacroscopiaAPI.getCestas().then((cestas) => {
      this.props.actions.preencherCestas(cestas);
    });
  }

  onChangeCentroDeResponsabilidade(valor) {
    this.setState({
      centroResponsabilidades: valor,
    });
  }

  onChangeCesta(valor) {
    this.setState({
      cesta: valor,
    });
  }

  onClickCheckboxBloco(bloco, numero) {
    const blocoCesta = {
      bloco: bloco,
      numero: numero,
      centroResponsabilidade: this.state.centroResponsabilidades,
      cesta: this.state.cesta,
    };
    this.props.actions.delegarBlocoParaCesta([blocoCesta]);
  }
}

const mapStateToProps = (state) => {
  return {
    centroDeResponsabilidades: state.macroscopia.centroResponsabilidades,
    cestas: state.macroscopia.cestas,
    blocos: state.macroscopia.blocos,
    blocoNaCesta: state.macroscopia.blocoNaCesta,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(CestaContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/cesta/cesta.container.js